import { Link } from 'react-router-dom'
import {
  RefreshCw, BarChart3, Package, Users, DollarSign,
  Tag, Layers, ArrowRight, Receipt, Bike, Wrench, FileText,
} from 'lucide-react'

const B = '/comercial/relatorios-gerenciais/'
const RELATORIOS = [
  {
    grupo: 'Vendas',
    items: [
      { to: B + 'vendas-geral', label: 'Vendas Geral', desc: 'Últimas vendas detalhadas (bruto, líquido, observação)', icon: Receipt, status: 'novo' },
      { to: B + 'vendas-vendedor', label: 'Vendas por Vendedor', desc: 'Total vendido e ticket por vendedor', icon: Users, status: 'pronto' },
      { to: B + 'vendas-produto', label: 'Vendas por Produto', desc: 'Quantidade e valor por item', icon: Package, status: 'pronto' },
      { to: B + 'vendas-cliente', label: 'Vendas por Cliente', desc: 'Ranking de receita por cliente', icon: Users, status: 'pronto' },
      { to: B + 'vendas-periodo', label: 'Vendas por Período', desc: 'Evolução por dia ou mês', icon: BarChart3, status: 'pronto' },
      { to: B + 'vendas-grupo', label: 'Vendas por Grupo/Subgrupo', desc: 'Receita por categoria', icon: Layers, status: 'pronto' },
      { to: B + 'vendas-marca', label: 'Vendas por Marca', desc: 'Receita por marca/fabricante', icon: Tag, status: 'novo' },
      { to: B + 'bikes-usadas', label: 'Bikes Usadas (troca)', desc: 'Bikes recebidas como pagamento — avaliação, filial e situação', icon: Bike, status: 'novo' },
    ],
  },
  {
    grupo: 'Serviços',
    items: [
      { to: B + 'servicos-tecnico', label: 'Serviços por Técnico/Mecânico', desc: 'OS, mão de obra, peças e ticket médio por técnico', icon: Wrench, status: 'novo' },
      { to: B + 'oficina-pecas', label: 'Oficina — Peças Vendidas', desc: 'Quais peças saíram pela oficina, quantidade e valor', icon: Package, status: 'novo' },
      { to: B + 'oficina-pecas-os', label: 'Oficina — Peças x Mão de Obra', desc: 'Cada OS com peça e serviço separados', icon: Wrench, status: 'novo' },
    ],
  },
  {
    grupo: 'Fiscal',
    items: [
      { to: B + 'avulsas-natureza', label: 'Notas Avulsas por Natureza', desc: 'Transferências, remessas e devoluções — quanto saiu por operação', icon: FileText, status: 'novo' },
    ],
  },
  {
    grupo: 'Contas a Pagar',
    items: [
      { to: B + 'cp-fornecedor', label: 'A Pagar por Fornecedor', desc: 'Total, pago e em aberto por fornecedor', icon: Users, status: 'pronto' },
      { to: B + 'cp-periodo', label: 'A Pagar por Período', desc: 'Por mês de vencimento', icon: BarChart3, status: 'pronto' },
      { to: B + 'cp-status', label: 'A Pagar por Status', desc: 'Aberto, pago, cancelado…', icon: DollarSign, status: 'pronto' },
    ],
  },
  {
    grupo: 'Contas a Receber',
    items: [
      { to: B + 'cr-cliente', label: 'A Receber por Cliente', desc: 'Total, recebido e em aberto por cliente', icon: Users, status: 'pronto' },
      { to: B + 'cr-periodo', label: 'A Receber por Período', desc: 'Por mês de vencimento', icon: BarChart3, status: 'pronto' },
      { to: B + 'cr-status', label: 'A Receber por Status', desc: 'Aberto, pago, cancelado…', icon: DollarSign, status: 'pronto' },
    ],
  },
  {
    grupo: 'Produtos e Estoque',
    items: [
      { to: '/relatorios/giro-produtos', label: 'Giro de Produtos', desc: 'Curva ABC, dias de cobertura, ruptura', icon: RefreshCw, status: 'novo' },
      { to: '/relatorios/estoque', label: 'Posição de Estoque', desc: 'Valor em custo vs venda, ruptura', icon: Package, status: 'pronto' },
      { to: '/relatorios/produtos-categoria', label: 'Produtos por Categoria', desc: 'Distribuição do catálogo', icon: Layers, status: 'pronto' },
    ],
  },
]

const COR_STATUS: any = {
  pronto: 'bg-emerald-100 text-emerald-800',
  novo: 'bg-violet-100 text-violet-800',
  em_breve: 'bg-ink-100 text-ink-500',
}

export default function RelatoriosGerenciaisPage() {
  return (
    <div className="p-4 lg:p-6 space-y-5">
      <div>
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <BarChart3 size={22} className="text-violet-600" /> Relatórios Gerenciais
        </h1>
        <p className="text-xs text-ink-500">Hub central de inteligência de negócio. Dashboards, análises e indicadores.</p>
      </div>

      {RELATORIOS.map(g => (
        <div key={g.grupo}>
          <h2 className="text-sm font-semibold text-ink-700 uppercase tracking-wide mb-2">{g.grupo}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {g.items.map((r: any) => {
              const Icon = r.icon
              const desabilitado = r.status === 'em_breve'
              return (
                <Link
                  key={r.label}
                  to={r.to}
                  className={`relative group border rounded-lg p-4 transition ${
                    desabilitado
                      ? 'border-ink-200 bg-ink-50 cursor-default pointer-events-none'
                      : 'border-ink-200 bg-white hover:border-violet-400 hover:shadow-md'
                  }`}
                >
                  <div className="flex items-start gap-3">
                    <div className={`p-2 rounded-lg ${desabilitado ? 'bg-ink-100' : 'bg-violet-50'}`}>
                      <Icon size={18} className={desabilitado ? 'text-ink-400' : 'text-violet-600'} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-0.5">
                        <h3 className={`font-semibold text-sm truncate ${desabilitado ? 'text-ink-500' : 'text-ink-900'}`}>{r.label}</h3>
                        <span className={`text-[9px] px-1.5 py-0.5 rounded font-semibold uppercase ${COR_STATUS[r.status]}`}>
                          {r.status === 'em_breve' ? 'em breve' : r.status}
                        </span>
                      </div>
                      <p className={`text-xs ${desabilitado ? 'text-ink-400' : 'text-ink-600'}`}>{r.desc}</p>
                    </div>
                    {!desabilitado && (
                      <ArrowRight size={14} className="text-ink-400 group-hover:text-violet-600 mt-1 flex-shrink-0" />
                    )}
                  </div>
                </Link>
              )
            })}
          </div>
        </div>
      ))}
    </div>
  )
}
